exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video[data-v-29b851e7]{width:100%;height:239px !important}.video video[data-v-29b851e7]{width:100%;height:100%}", ""]);

// exports
